import React, {Component} from 'react';
import './VirtualAssistCaseButton.scss';
import {PropTypes} from 'prop-types';
import {connect} from 'react-redux';
import DashboardButton from "../button/DashboardButton";
import {Language} from "../../language/services/constants";
import {getLanguage} from "../../../store/rootReducer";
import HrbTranslate from "../../language/HrbTranslate";
import auth from '../../../services/auth/AuthProvider';

class VirtualAssistCaseButton extends Component {

  getCaseItemDescriptionValue = (key) => {
    let descriptionItem;
    if (this.props.language === Language.FRENCH) {
      descriptionItem = this.props.caseItem.description_fr;
    } else {
      descriptionItem = this.props.caseItem.description_en;
    }
      return descriptionItem[key];
  };

  goToCaseItem = () => {
    auth.redirect('RTE', 'login');
  };

  render() {
    return (
        <DashboardButton onClick={this.goToCaseItem}>
          <div className="va-dashboard-single-item">
            <HrbTranslate text="dashboard.va_tax_expert_existing_case"/>
          </div>
        </DashboardButton>
    );
  }
}


VirtualAssistCaseButton.propTypes = {
  caseItem: PropTypes.object
};

const mapStateToProps = (state) => {
  return {
    language: getLanguage(state)
  }
};

export default connect(
    mapStateToProps
)(VirtualAssistCaseButton);